import { __assign, __rest } from "tslib";
import React, { useState, useCallback, useRef } from 'react';
import StandardMenuContent from '../StandardMenuContent';
import classnames from 'classnames';
import ScrollableContent from '../../../../ScrollableContent';
import ArrowUp from '@wix/da-ds/pkg/Icons/ArrowUp';
import ArrowDown from '@wix/da-ds/pkg/Icons/ArrowDown';
import s from './ScrollableMenuContent.scss';
var ScrollableMenuContent = function (_a) {
    var label = _a.label, labelClassName = _a.labelClassName, withScrollableArrows = _a.withScrollableArrows, contentProps = __rest(_a, ["label", "labelClassName", "withScrollableArrows"]);
    var _b = useState(0), scrollTop = _b[0], setScrollTop = _b[1];
    var _c = useState(0), distanceToBottom = _c[0], setDistanceToBottom = _c[1];
    var scrollableRef = useRef(null);
    var setScrollableRef = useCallback(function (node) {
        scrollableRef.current = node;
    }, []);
    var onScrolled = useCallback(function (top, bottom) {
        setScrollTop(top);
        setDistanceToBottom(bottom);
    }, []);
    var onScrollClick = useCallback(function (e, distance) {
        if (!scrollableRef.current) {
            return;
        }
        scrollableRef.current.scrollBy({ top: distance, behavior: 'smooth' });
        e.stopPropagation();
    }, []);
    return (React.createElement(React.Fragment, null,
        label && (React.createElement("div", { className: classnames(s['label'], labelClassName, scrollTop > 0 && s['sticky']) }, label)),
        React.createElement(ScrollableContent, { className: classnames(s['scrollable-content'], scrollTop === 0 && s['top'], distanceToBottom === 0 && s['bottom']), onScrolled: onScrolled, innerRef: setScrollableRef },
            React.createElement(StandardMenuContent, __assign({}, contentProps), withScrollableArrows && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: s['scroll-arrow-up'], onClick: function (e) { return onScrollClick(e, -200); } },
                    React.createElement("div", { className: s['scroll-arrow-clickable'] },
                        React.createElement(ArrowUp, { disableDefaultColors: true }))),
                React.createElement("div", { className: s['scroll-arrow-down'], onClick: function (e) { return onScrollClick(e, 200); } },
                    React.createElement("div", { className: s['scroll-arrow-clickable'] },
                        React.createElement(ArrowDown, { disableDefaultColors: true })))))))));
};
ScrollableMenuContent.displayName = 'ScrollableMenuContent';
export default ScrollableMenuContent;
//# sourceMappingURL=ScrollableMenuContent.js.map